import { range } from '@sorare/core/src/lib/arrays';

import { SearchPlayerRowSkeleton } from './SearchPlayerRowSkeleton/index.tsx';

type Props = {
  rowsNumber: number;
};

export const SearchPlayerRowSkeletons = ({ rowsNumber }: Props) => {
  return range(rowsNumber).map(i => <SearchPlayerRowSkeleton key={i} />);
};
